import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasEmptyValues'
})
export class HasEmptyValuesPipe implements PipeTransform {
    transform(objectOrArray: any) {
      let values;

      if (!Array.isArray(objectOrArray)) {
        values = Object.values(objectOrArray);
      } else {
        values = objectOrArray;
      }

      return values.every(value => {
        return !value;
        // return value === undefined || value === null;
      });
    }
}
